














import mixins from 'vue-typed-mixins';
import BookshelfFormVue from '@/components/resource/BookshelfForm.vue';
import ResourceUtils, { Bookshelf, Resource } from '@/utils/ResourceUtils';
export default mixins().extend({
  components: {
    BookshelfForm: BookshelfFormVue,
  },

  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },

  data(): {
    item?: Partial<Bookshelf>;
    resources?: Resource[];
  } {
    return {
      item: undefined,
      resources: undefined,
    };
  },

  async mounted() {
    try {
      this.loadResources(); // async load resources
      if (this.id) {
        this.item = await ResourceUtils.api.bookshelf.get(this.id);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async save() {
      if (this.item) {
        try {
          this.$alert.hide('save');
          this.item = await ResourceUtils.api.bookshelf.update(this.item);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.item?.name],
            }),
          });
        } catch (error) {
          this.$alert.show('save', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },

    async loadResources() {
      try {
        this.$alert.hide('loadResources');
        this.resources = await ResourceUtils.api.resource.list();
      } catch (error) {
        this.$alert.show('loadResources', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
